module.exports = __webpack_public_path__ + "img/bcc383.e623224e.jpeg";